import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import SearchIcon from '@material-ui/icons/Search';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';

import ReorderIcon from '@material-ui/icons/Reorder';
import MapIcon from '@material-ui/icons/Map';

import { makeStyles } from '@material-ui/core/styles';

import MapCard from '../landing-page/MapCard';
import MemberGrid from '../landing-page/MemberGrid';
import { getState } from '../landing-page/MemberCard';
import Splash from '../landing-page/Splash';
import { STATE_LOOKUP, SENATE, HOUSE } from '../../common/Utils';

const LISTVIEW = "List";
const MAPVIEW = "Map";
const RETIRING = "Retiring";
const NEW = "New";
const SHOWGRID = "Show Grid";
const SHOWFILTERS = "Show Filters";
const ATOZ = "aToZ";
const SENIORTYOLDEST = "seniortyOldest";
const SENIORITYNEWEST = "seniortyNewest";
const DEFAULTFILTERS = {party: "", state: "", chamber: "", status: "", term: "", sort: ATOZ, memberView: LISTVIEW};


const useStyles = makeStyles((theme) => ({
	container: {
		marginTop: 20,
	},
	pagination: {
		marginTop: 20,
		margin: 'auto',
 		width: '50%'
	},
	search: {
    position: 'relative',
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#C0C2C4",
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  filterPaper: {
    backgroundColor: "#F4F4F4",
    padding: 20,
    marginTop: 5
  },
  filterLabel: {
    color: "#333333",
    fontFamily: "Graphik",
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: 0
  },
  stateDropdown: {
    width: 150
  },
  termDropdown: {
    width: 170
  },
  radio: {
    '&$checked': {
      color: '#4B8DF8'
    }
  },
  checked: {},
  sortRow: {
    height: 0
  },
  sortDropdown: {
    width: 150
  },
  stateFilterInstructions: {
    color: "#333333",
    fontFamily: "Graphik",
    fontSize: 12,
    letterSpacing: 0,
    marginTop: 10,
    marginBottom: 10
  },
  filterChoices: {
    color: "#333333",
    fontFamily: "Graphik",
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0,
  },
  mobileFilterButton: {
    margin: "0 auto",
    color: "#333333",
    fontFamily: "Graphik",
    fontSize: 14,
  },
  mobileApplyButton: {
    margin: "0 12 auto",
    fontFamily: "Graphik",
    fontSize: 14,
    backgroundColor: "#005383",
    color: "white"
  },
  mobileClearButton: {
    margin: "0 12px auto",
    fontFamily: "Graphik",
    fontSize: 14,
    color: "#005383",
    border: "2px solid #005383"
  },
  mobileFilterTitle: {
    color: "#333333",
    fontFamily: "Graphik",
    fontSize: 24,
    fontWeight: 500,
    letterSpacing: 0,
    padding: 20
  },
  buttonDiv: {
    marginBottom: 10
  },
  mobileFilterSubtitle: {
    color: "#333333",
    fontFamily: "Graphik",
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0,
    padding: 20
  },
  viewButton: {
    float: "right",
    color: "#333333",
    fontFamily: "Graphik",
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0,
    paddingTop: 20,
    outline: 'none!important'
  },
  buttonIcon: {
    marginLeft: 10,
    marginRight: 5
  },
  dialog: {
    position: 'absolute',
    top: 50
  }
}));

/** Utility Functions */

function getChamber(member) {
  if (member.positions !== undefined && member.positions.length > 0) {
    const title = member.positions[0].title;
    if (title === "Senator") {
      return SENATE;
    } else {
      return HOUSE;
    }
  }
  return "";
}

const getStatus = (member) => {
  if (member.statusNote !== undefined && member.statusNote.includes("retired")) {
    return RETIRING;
  } else if (member.positionDetails !== undefined &&
            member.positionDetails.numberTerms !== undefined &&
            getMemberTerm(member) === "1") {
    return NEW;
  } else return "";
}

const getMemberTerm = (member) => {
  const numberPattern = /\d+/g;
  if (member.positionDetails !== undefined && member.positionDetails.numberTerms !== undefined) {
    let matches = member.positionDetails.numberTerms.match(numberPattern);
    return (matches.length > 0)? matches[0] : 0;
  } else {
    return 0;
  }
}

const getMaxTerm = (memberList) => {
  if (memberList !== undefined) {
    return Math.max.apply(Math, memberList.map(getMemberTerm));
  } else {
    return 0;
  }
}

/** Search Bar */
function updateSearch(event, setSearchStr) {
	if (event.target.value !== undefined && event.target.value.length >= 3) {
    setSearchStr(event.target.value);
	} else if (event.target.value === undefined || event.target.value.length < 3) {
    setSearchStr("");
  }
	
}

function getSearchBar(setSearchStr, classes) {
  return (
    <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search…"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
			    inputProps={{ 'aria-label': 'search' }}
			    onChange={(event)=> updateSearch(event, setSearchStr)}
        />
      </div>
  )
}

/** Party Filter */
function getPartyFilterRadioGroup(filters, setFilters, classes) {
  return (
    <Paper elevation={0} className={classes.filterPaper}>
      <FormControl component="fieldset">
          <FormLabel focused={false} className={classes.filterLabel} component="legend">Party</FormLabel>
          <RadioGroup 
            aria-label="party" 
            value={(filters.party !== undefined) ? filters.party : ""} 
            name="party"
          >
            <FormControlLabel
              value="Democratic"
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />} size="small" onClick={(event) => handleFilters(event.target.value, filters, "party", setFilters)}/>}
              label="Democratic" />
            <FormControlLabel
              value="Republican"
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />} size="small" onClick={(event) => handleFilters(event.target.value, filters, "party", setFilters)}/>}
              label="Republican" />
            <FormControlLabel
              value="Independent"
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />} size="small" onClick={(event) => handleFilters(event.target.value, filters, "party", setFilters)}/>}
              label="Independent" />
            <FormControlLabel
              value="Libertarian"
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />} size="small" onClick={(event) => handleFilters(event.target.value, filters, "party", setFilters)}/>}
              label="Libertarian" />
          </RadioGroup>
        </FormControl>
      </Paper>
    );
}

/** State filter */
function getStateDropdown(filters, setFilters, classes) {
  return (
    <Paper elevation={0} className={classes.filterPaper}>
      <div className={classes.filterLabel}>State</div>
      <div className={classes.stateFilterInstructions}>Search for a state by typing the name or use the dropdown.</div>
      <FormControl variant="filled" className={classes.stateDropdown}>
          <InputLabel className={classes.filterChoices} htmlFor="state">Type a State</InputLabel>
          <Select
            native
            value={filters.state}
            classes={{select: classes.filterChoices}} 
            onChange={(event) => handleFilters(event.target.value, filters, "state", setFilters)}
            inputProps={{
              name: 'state',
              id: 'state',
            }}
          >
            <option aria-label="None" value="" />
            {Object.values(STATE_LOOKUP).map((state) => (<option key={state} value={state}>{state}</option>) )}
          </Select>
      </FormControl>
    </Paper> 
  );
}

function handleChamberClick(value, filters, setFilters) {
  if (!(filters.memberView === MAPVIEW && filters.chamber === value)) {
    handleFilters(value, filters, "chamber", setFilters);
  }
}

/** Chamber Filter */
function getChamberRadioGroup(filters, setFilters, classes) {
  return (
    <Paper elevation={0} className={classes.filterPaper}>
      <FormControl component="fieldset">
          <FormLabel focused={false} className={classes.filterLabel} component="legend">Chamber</FormLabel>
          <RadioGroup 
            aria-label="chamber" 
            value={(filters.chamber !== undefined) ? filters.chamber : ""} 
            name="chamber"
          >
            <FormControlLabel
              value={HOUSE}
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />}size="small" onClick={(event) => handleChamberClick(event.target.value, filters, setFilters)}/>}
              label="House" />
            <FormControlLabel
              value={SENATE}
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />} size="small" onClick={(event) => handleChamberClick(event.target.value, filters, setFilters)}/>}
              label="Senate" />
          </RadioGroup>
        </FormControl>
      </Paper>
    );
}

/** Chamber Filter */
function getStatusRadioGroup(filters, setFilters, classes) {
  return (
    <Paper elevation={0} className={classes.filterPaper}>
      <FormControl component="fieldset">
          <FormLabel focused={false} className={classes.filterLabel} component="legend">Status</FormLabel>
          <RadioGroup 
            aria-label="status" 
            value={(filters.status !== undefined) ? filters.status : ""} 
            name="status"
          >
            <FormControlLabel
              value={NEW}
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />}size="small" onClick={(event) => handleFilters(event.target.value, filters, "status", setFilters)}/>}
              label="New Members" />
            <FormControlLabel
              value={RETIRING}
              classes={{label: classes.filterChoices}}
              control={<Radio disableRipple classes={{root: classes.radio, checked: classes.checked}} icon={<CircleUnchecked />} checkedIcon={<CircleCheckedFilled />} size="small" onClick={(event) => handleFilters(event.target.value, filters, "status", setFilters)}/>}
              label="Retiring Members" />
          </RadioGroup>
        </FormControl>
      </Paper>
    );
}

/** State filter */
function getTermDropdown(maxTerm, filters, setFilters, classes) {
  let terms = [];

  for (let i=1 ;i <= maxTerm; i++) {
    terms.push(<option key={i} value={i}>{i} term</option>);
  }

  return (
    <Paper elevation={0} className={classes.filterPaper}>
      <div className={classes.filterLabel}>Congress Term</div>
      <div className={classes.stateFilterInstructions}>Type the number for congress term or use the dropdown.</div>
      <FormControl variant="filled" className={classes.termDropdown}>
          <InputLabel className={classes.filterChoices} htmlFor="state">Type Congress Term</InputLabel>
          <Select
            native
            value={filters.term}
            classes={{select: classes.filterChoices}} 
            onChange={(event) => handleFilters(event.target.value, filters, "term", setFilters)}
            inputProps={{
              name: 'term',
              id: 'term',
            }}
          >
            <option aria-label="None" value="" />
            {terms}
          </Select>
      </FormControl>
    </Paper> 
  );
}

/** Sort Dropdow */
function getMobileSortDropdown(filters, setFilters, classes) {
  return (
      <FormControl className={classes.sortDropdown} style={{float:"left"}}>
          <Select
            native
            variant="outlined"
            value={filters.sort}
            classes={{select: classes.filterChoices}} 
            onChange={(event) => handleFilters(event.target.value, filters, "sort", setFilters)}
            inputProps={{
              name: 'term',
              id: 'term',
            }}
          >
            <option value={ATOZ}>Sort By Name A-Z</option>
            <option value={SENIORTYOLDEST}>Sort By Seniorty(Oldest First)</option>
            <option value={SENIORITYNEWEST}>Sort By Seniorty(Newwst First)</option>
          </Select>
      </FormControl>
  );
}

function handleMapViewClick(filters, setFilters) {
  let newFilters = {...filters};

  if (filters.chamber === "") {
    newFilters["chamber"] = HOUSE;
  }
  newFilters["memberView"] = MAPVIEW;
  setFilters(newFilters);
}

const getViewButton = (filters, setFilters, classes) => {
  if (filters.memberView === LISTVIEW) {
    return (
        <React.Fragment>
          <Button classes={{root: classes.viewButton}} onClick={() => {handleMapViewClick(filters, setFilters)}}>
            <MapIcon className={classes.buttonIcon}/>
            Map View
          </Button>        
        </React.Fragment>
      );
  } else {
      return (
        <React.Fragment>
          <Button classes={{root: classes.viewButton}} onClick={() => {handleFilters(LISTVIEW, filters, "memberView", setFilters)}}>
            <ReorderIcon className={classes.buttonIcon}/>
            List View
          </Button>         
        </React.Fragment>
      );
  }
}

function getSortDropdown(filters, setFilters, classes) {
  
  return (
    <React.Fragment>
      {getViewButton(filters,setFilters, classes)}
      <FormControl className={classes.sortDropdown} style={{float:"right"}}>
          <InputLabel className={classes.filterChoices} htmlFor="state">Sort By</InputLabel>
          <Select
            native
            variant="standard"
            value={filters.sort}
            classes={{select: classes.filterChoices}} 
            onChange={(event) => handleFilters(event.target.value, filters, "sort", setFilters)}
            inputProps={{
              name: 'term',
              id: 'term',
            }}
          >
            <option value={ATOZ}>Name A-Z</option>
            <option value={SENIORTYOLDEST}>Seniorty(Oldest First)</option>
            <option value={SENIORITYNEWEST}>Seniorty(Newwst First)</option>
          </Select>
      </FormControl>
    </React.Fragment>
  );
}

/** Filter logic */
function getFilters(filters, setFilters, classes) {
  return (
    <>
        <Grid item key='partyFilter' xs={12}>
          {getPartyFilterRadioGroup(filters, setFilters, classes)}
        </Grid>
        <Grid item key='stateFilter' xs={12}>
          {getStateDropdown(filters, setFilters, classes)}
        </Grid>
        <Grid item key='chamberFilter' xs={12}>
          {getChamberRadioGroup(filters, setFilters, classes)}
        </Grid>
        <Grid item key='statusFilter' xs={12}>
          {getStatusRadioGroup(filters, setFilters, classes)}
        </Grid>
    </>
  );
}

function handleFilters(value, filters, filterName, setFilters) {
   if (value === filters[filterName]) {
    filters[filterName] = "";
    setFilters({...filters});
  } else {
    let newFilters = {...filters};
    newFilters[filterName] = value;
    setFilters(newFilters);
  }
}

function sortMemberList(memberList, filters) {
  if (memberList === undefined || filters.sort === undefined) {
    return memberList;
  }
  const nameSort = (ma, mb) => {
      var nameA = ma.lastName.toUpperCase(); // ignore upper and lowercase
      var nameB = mb.lastName.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    };

  const termSort = (ma, mb) => {
      var termA = getMemberTerm(ma);
      var termB = getMemberTerm(mb);
      if (termA < termB) {
        return -1;
      }
      if (termA > termB) {
        return 1;
      }
      return 0;
    };


    if (filters.sort === ATOZ) {
      return memberList.sort(nameSort)
    }
    if (filters.sort === SENIORITYNEWEST) {
      return memberList.sort(termSort);
    }
    if (filters.sort === SENIORTYOLDEST) {
      return memberList.sort(termSort).reverse();
    }
}

function filterMemberList(memberList, memberFilters) {
  return memberList.filter(function(member) {
      return ((memberFilters.party === "" || member.party.label === memberFilters.party) &&
              (memberFilters.state === "" || memberFilters.state === getState(member)) &&
              (memberFilters.chamber === "" || memberFilters.chamber === getChamber(member)) &&
              (memberFilters.status === "" || memberFilters.status === getStatus(member)) &&
              (memberFilters.term === "" || getMemberTerm(member) === memberFilters.term));
  });
}

function searchMemberList(memberList, searchStr) {
  if (searchStr !== undefined && searchStr.length >= 3) {
		return memberList.filter(member => member.fullName.toLowerCase().includes(searchStr.toLowerCase()));
	} else {
		return memberList;
  }
}

function filterSeachandSortMemberList(memberList, searchStr, memberFilters) {
  let filteredMemberlist, sortedMemberList, searchedMemberList;

  searchedMemberList = searchMemberList(memberList, searchStr);
  
	filteredMemberlist = filterMemberList(searchedMemberList, memberFilters);

  sortedMemberList = sortMemberList(filteredMemberlist, memberFilters);
    
	return sortedMemberList;
}

function getMemberViewComponent(displayMemberList, filters) {
  if (filters.memberView === LISTVIEW) {
    return <MemberGrid memberList={displayMemberList} page={1}/>
  } else {
    const mapType = (filters.chamber === "")? "House" : filters.chamber;
    return <MapCard memberList={displayMemberList} mapType={mapType}/>;
  }
}

function getMobileView(memberViewComponent, mobileView, setMobileView, setSearchStr, filters, setFilters, classes) {

  if (mobileView === SHOWGRID) {
    return (
      <>
        <Button className={classes.mobileFilterButton} onClick={() => setMobileView(SHOWFILTERS)}>Filter</Button>
        <Grid item key="search" xs={12}>
            {getSearchBar(setSearchStr, classes)}
        </Grid>
        <Grid item key='grid' xs={12} md={9}>
          {memberViewComponent}
        </Grid>
      </>
    );
  } else {
    return (
      <>
      <Grid item key="sortTitle" xs={12}>
        <span className={classes.mobileFilterTitle}>Sort & Filter</span>
      </Grid>
      <Grid item key="sortSubtitle" xs={12}>
        {getMobileSortDropdown(filters, setFilters, classes)}
      </Grid>
      {getFilters(filters, setFilters, classes)}
      <Grid container justify="center">
        <div className={classes.buttonDiv}>
          <Button variant="outlined" className={classes.mobileClearButton} onClick={() => setFilters(DEFAULTFILTERS)}>Clear All</Button>
          <Button variant="contained" className={classes.mobileApplyButton} onClick={() => setMobileView(SHOWGRID)}>Apply</Button>
        </div>
      </Grid>
      </>
    );
  }
}

const LandingPage = (props) => {
  const {
    memberList,
    splash,
    overlay,
    showOldMemberModal
  } = props;
  const classes = useStyles();
  const [searchStr, setSearchStr] = useState("");
  const [filters, setFilters] = useState(DEFAULTFILTERS);
  const [mobileView, setMobileView] = useState(SHOWGRID);
  const [open, setOpen] = React.useState(showOldMemberModal);
  const handleClose = () => {
    setOpen(false);
  };
  const displayMemberList = filterSeachandSortMemberList(memberList, searchStr, filters);
  const memberViewComponent = getMemberViewComponent(displayMemberList, filters);
 
  return (
    <Grid container spacing={3} style={{backgroundColor: 'white'}}>
      <Grid item key='splash' xs={12}>
        <Splash splash={splash} overlay={overlay}/>	  
      </Grid>
      <Hidden smDown>
        <Grid item key="search" xs={12}>
          {getSearchBar(setSearchStr, classes)}
        </Grid> 
        <Grid className={classes.sortRow} item key="sort" xs={12}>
          {getSortDropdown(filters, setFilters, classes)}
        </Grid>
        <Grid item key='filters' md={3}>
            {getFilters(filters, setFilters, classes)}
        </Grid>
        <Grid item key='grid' xs={12} md={9}>
          {memberViewComponent}
        </Grid>
      </Hidden>
      <Hidden mdUp>
        {getMobileView(memberViewComponent, mobileView, setMobileView, setSearchStr, filters, setFilters, classes)}
      </Hidden>
      <Dialog
        classes={{
          paper: classes.dialog
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This person is a former member of Congress and does not serve in the current Congress. 
				    You can find the member’s successor by using our search functionality.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default LandingPage;